import { debugConsole } from "./debugConsole";

const TAB_ID_KEY = "mqttTabId";

// In-memory fallback keeps the id stable within this tab if sessionStorage
// throws (private mode, blocked storage, etc.).
let fallbackTabId: string | null = null;

/**
 * Returns a UUID unique to this browser tab, persisted in sessionStorage.
 * Combined with the device id it gives each tab its own MQTT clientId so two
 * tabs of the same user don't share one session (MQTT brokers kick the older
 * connection when a clientId is reused).
 */
export const getOrCreateTabId = (): string => {
  try {
    const stored = sessionStorage.getItem(TAB_ID_KEY);
    if (stored) return stored;

    const newId = crypto.randomUUID();
    sessionStorage.setItem(TAB_ID_KEY, newId);
    return newId;
  } catch (error) {
    debugConsole("Error accessing sessionStorage for tabId:", error);
    if (!fallbackTabId) {
      fallbackTabId = crypto.randomUUID();
    }
    return fallbackTabId;
  }
};
